import React from "react";
import ReactDOM from "react-dom/client";
import ProductDeliveryPriceModal from "./components/ProductDeliveryPriceModal";

export default new class ProductDeliveryPriceModalService {
    public init(): void {
        for (const showDeliveryInfoButton of document.querySelectorAll<HTMLSpanElement>(".js-delivery-information-modal")) {
            showDeliveryInfoButton.addEventListener("click", (event: MouseEvent): void => {
                event.preventDefault();
                this.showDeliveryPriceModal();
            });
        }
    }

    public showDeliveryPriceModal(): void {
        const containerElement = document.createElement("div");
        const root = ReactDOM.createRoot(containerElement);

        root.render(<ProductDeliveryPriceModal
            onAfterClose={(): void => {
                root.unmount();
                containerElement.remove();
            }}
        />);
    }
}();
